import { lazy } from 'react'
import Loadable from '../components/Loadable'
import Dashboard from '../layout/Dashboard'
import PrivateRoute from "./PrivateRoute"
import Profile from '../layout/Dashboard/Header/HeaderContent/Profile'

const Exams = Loadable(lazy(() => import('../pages/exams')))
const ExamDetail = Loadable(lazy(() => import('../pages/exam-detail')))
const PartTest = Loadable(lazy(() => import('../pages/part-test')))
const ExamTest = Loadable(lazy(() => import('../pages/exam-test')))
const TimeUp = Loadable(lazy(() => import('../pages/time-up')))
const ChangePasswordPage = Loadable(lazy(() => import('../pages/change-password')))
const UserProfile = Loadable(lazy(() => import('../pages/profile')))
const History = Loadable(lazy(() => import('../pages/history')))
const WriteTestReview = Loadable(lazy(() => import('../pages/review-write-test')))
const NotFoundPage = Loadable(lazy(() => import('../pages/error/notFoundPage')))
const ClassPage = Loadable(lazy(() => import('../pages/class')))
const ClassDetailPage = Loadable(lazy(() => import('../pages/class-detail')))
const DirectMockResultsPage = Loadable(lazy(() => import('../pages/direct-mock-results')))

// ==============================|| MAIN ROUTING ||============================== //


const MainRoutes = {
  path: '/',
  element: <PrivateRoute element={<Dashboard />} />,  // Truy?n v�o element ? d�y
  children: [
    {
      path: '/',
      element: <Exams />
    },
    {
      path: '/change-password',
      element: <PrivateRoute element={<ChangePasswordPage />} />
    },
    {
      path: '/profile',
      element: <PrivateRoute element={<UserProfile />} />
    },
    {
      path: '/history',
      element: <PrivateRoute element={<History />} />
    },
    {
      path: '/direct-mock-results',
      element: <PrivateRoute element={<DirectMockResultsPage />} />
    },
    {
      path: '/write-test-review/:id',
      element: <PrivateRoute element={<WriteTestReview />} />
    },
    {
      path: '/exam-detail/:id',
      element: <PrivateRoute element={<ExamDetail />} />
    },
    {
      path: '/exam-test/:id',
      element: <PrivateRoute element={<ExamTest />} />
    },
    {
      path: '/part-test/:id',
      element: <PrivateRoute element={<PartTest />} />
    },
    {
      path: '/time-up/:id',
      element: <PrivateRoute element={<TimeUp />} />
    },
    {
      path: '/class',
      element: <PrivateRoute element={<ClassPage />} />
    },
    {
      path: '/class-detail/:id',
      element: <PrivateRoute element={<ClassDetailPage />} />
    },
    {
      path: '*',
      element: <NotFoundPage />
    },

  ]
}

export default MainRoutes

